<dx-box #workflowReimbursementRequest height="100%" width="100%" direction="col">
    <dxi-item baseSize="auto">
        <h2 class="page-header">
            Reimbursement Request
            <sup class="page-help-link">
                <a [href]="helpLink" target="_blank" class="fas fa-question-circle"></a>
            </sup>
            <i
                class="far fa-window-restore launch-page-link dx-theme-accent-as-text-color"
                title="Open page in new window"
                (click)="openPageInWindow()"
            ></i>
        </h2>
    </dxi-item>
    <dxi-item [ratio]="1">
        <dx-box width="100%" height="100%" direction="col" class="reimbursement-box-container cc-white-background">
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-box width="100%" height="100%" direction="row" class="box-filter-container">
                        <dxi-item [ratio]="1" [visible]="!selectedContext && !selectedContext?.communityId">
                            <div *dxTemplate>
                                <div class="row-container add-padding">
                                    <div class="field-label">Community:</div>
                                    <div class="field-component">
                                        <app-multi-column-selector
                                            [name]="'Community'"
                                            [gridSource]="communityList"
                                            [boxValue]="communityGridBoxValue"
                                            [valueExpr]="'communityId'"
                                            [displayExpr]="'communityName'"
                                            [columnDef]="communityColumns"
                                            [dropDownButtonTemplate]="'dropDownButton'"
                                            [dropDownOptions]="{ width: 'auto' }"
                                            [showClearButton]="true"
                                            [navigateToCommunity]="true"
                                            [placeholder]="'Select Community...'"
                                            [showHeaderFilters]="true"
                                            (gridSelectionEvent)="onCommunitySelection($event)"
                                        ></app-multi-column-selector>
                                    </div>
                                </div>
                            </div>
                        </dxi-item>
                        <dxi-item [ratio]="1">
                            <div *dxTemplate>
                                <div class="row-container">
                                    <div class="add-padding">
                                        <dx-button type="default" text="Refresh" [icon]="iconRefresh"></dx-button>
                                    </div>
                                    <div *ngIf="isInternalUser" class="add-padding">
                                        <dx-button
                                            type="default"
                                            [disabled]="!communityId"
                                            (onClick)="onNewReimbursementClick()"
                                        >
                                            <div *dxTemplate="let data of 'content'">
                                                <div class="row-container">
                                                    <div class="button-icon-padding">
                                                        <i [ngClass]="iconAdd"></i>
                                                    </div>
                                                    <div class="add-short-padding">New Reimbursement</div>
                                                    <div *ngIf="isInternalUser" class="button-icon-padding">
                                                        <app-security-info
                                                            iconColor="cc-white-icon"
                                                            securityIndicator="LOCK"
                                                            apiAction="POST"
                                                            apiUrl="api/wf/reimbursement"
                                                        ></app-security-info>
                                                    </div>
                                                </div>
                                            </div>
                                        </dx-button>
                                    </div>
                                </div>
                            </div>
                        </dxi-item>
                    </dx-box>
                </div>
            </dxi-item>
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <cc-data-grid-features
                        *ngIf="!!workflowReimbursements"
                        [stateConfig]="{ storageKey: 'WORKFLOW_REIMBURSEMENT_REQUEST', storeGroupings: true }"
                        [dataSource]="workflowReimbursements"
                    >
                        <dx-data-grid
                            #vendorEditGrid
                            appHasInternalUserColumns
                            width="100%"
                            height="100%"
                            [dataSource]="workflowReimbursements"
                        >
                            <dxi-column
                                name="InternalActions"
                                type="buttons"
                                caption="Action"
                                headerCellTemplate="lockHeaderCellTemplate"
                                alignment="center"
                                [width]="110"
                                [visibleIndex]="0"
                                [showInColumnChooser]="false"
                            >
                                <dxi-button template="template">
                                    <div *dxTemplate="let t of 'template'">
                                        <dx-button
                                            icon="runner"
                                            class="icon-button-content"
                                            [width]="84"
                                            [height]="26"
                                            type="normal"
                                            text="Action"
                                            (onClick)="onActionClick(t.data)"
                                        ></dx-button>
                                    </div>
                                </dxi-button>
                            </dxi-column>
                            <dxi-column
                                dataType="string"
                                dataField="managementCompany"
                                caption="Management Company"
                            ></dxi-column>
                            <dxi-column dataType="string" dataField="location" caption="Location"></dxi-column>
                            <dxi-column
                                name="RestrictedColumn|WORKFLOW_DETAILS"
                                dataType="number"
                                dataField="workFlowId"
                                caption="Workflow Id"
                                cellTemplate="workflowTemplate"
                            ></dxi-column>
                            <dxi-column dataType="string" dataField="workOrders" caption="Work Orders"></dxi-column>
                            <dxi-column dataType="string" dataField="invoiceNumber" caption="Invoice#"></dxi-column>
                            <dxi-column
                                dataType="date"
                                dataField="invoiceDate"
                                caption="Invoice Date"
                                [format]="dateFormat"
                            ></dxi-column>
                            <dxi-column
                                dataType="date"
                                dataField="datePosted"
                                caption="Date Posted"
                                [format]="dateFormat"
                            ></dxi-column>
                            <dxi-column
                                dataType="number"
                                dataField="invoiceAmount"
                                caption="Invoice Amount"
                                [format]="currencyFormat"
                            ></dxi-column>
                            <dxi-column
                                dataType="string"
                                dataField="workflowStatus"
                                caption="Workflow Status"
                                cellTemplate="workflowStatusCellTemplate"
                            ></dxi-column>
                            <dxi-column
                                dataType="string"
                                dataField="paymentStatus"
                                caption="Payment Status"
                            ></dxi-column>
                            <dxi-column
                                dataType="string"
                                dataField="accountNumber"
                                caption="Account Number"
                            ></dxi-column>
                            <dxi-column
                                dataType="string"
                                dataField="invoiceStatus"
                                caption="Invoice Status"
                            ></dxi-column>
                            <dxi-column
                                dataType="string"
                                caption="Invoice"
                                cellTemplate="invoiceCellTemplate"
                                alignment="center"
                                [allowGrouping]="false"
                            ></dxi-column>
                            <dxi-column
                                name="InternalLogs"
                                dataType="string"
                                caption="History"
                                headerCellTemplate="lockHeaderCellTemplate"
                                cellTemplate="historyCellTemplate"
                                alignment="center"
                                [showInColumnChooser]="false"
                                [allowFiltering]="false"
                                [allowHeaderFiltering]="false"
                                [allowGrouping]="false"
                                [allowSorting]="false"
                            ></dxi-column>
                            <dxi-column
                                name="InternalNotes"
                                dataField="hasNotes"
                                dataType="boolean"
                                caption="Notes"
                                headerCellTemplate="lockHeaderCellTemplate"
                                cellTemplate="notesCellTemplate"
                                alignment="center"
                                [allowGrouping]="false"
                            ></dxi-column>
                            <dxi-column
                                dataType="string"
                                caption="Board History"
                                cellTemplate="boardHistoryCellTemplate"
                                alignment="center"
                                [showInColumnChooser]="false"
                                [allowFiltering]="false"
                                [allowHeaderFiltering]="false"
                                [allowGrouping]="false"
                                [allowSorting]="false"
                            ></dxi-column>
                            <dxi-column
                                caption="Board Notes"
                                dataField="hasBoardNotes"
                                dataType="boolean"
                                alignment="center"
                                cellTemplate="boardNotesCellTemplate"
                                [allowGrouping]="false"
                            ></dxi-column>

                            <div *dxTemplate="let header of 'lockHeaderCellTemplate'">
                                {{ header.column.caption }}
                                <app-security-info
                                    securityIndicator="LOCK"
                                    apiAction="GET"
                                    apiUrl="api/wf/reimbursement"
                                ></app-security-info>
                            </div>

                            <div *dxTemplate="let d of 'invoiceCellTemplate'">
                                <i
                                    class="cc-1-5x icon-content cc-icon-pdf"
                                    [ngClass]="iconPDF"
                                    (click)="onDownloadFile(d.data)"
                                ></i>
                            </div>

                            <div *dxTemplate="let t of 'historyCellTemplate'">
                                <i
                                    class="cc-1-5x icon-content dx-theme-accent-as-text-color"
                                    [ngClass]="iconHistory"
                                    (click)="onHistoryClick(t.data)"
                                ></i>
                            </div>
                            <div *dxTemplate="let t of 'boardHistoryCellTemplate'">
                                <i
                                    class="cc-1-5x icon-content dx-theme-accent-as-text-color"
                                    [ngClass]="iconHistory"
                                    (click)="onBoardHistoryClick(t.data)"
                                ></i>
                            </div>

                            <div *dxTemplate="let d of 'notesCellTemplate'">
                                <div *ngIf="d.data.hasNotes">
                                    <i
                                        class="cc-1-5x icon-content cc-icon-content cc-icon-check"
                                        [ngClass]="iconNotes"
                                        (click)="onNotesClick(d.data)"
                                    ></i>
                                </div>

                                <div *ngIf="!d.data.hasNotes">
                                    <i
                                        class="cc-1-5x icon-content dx-theme-accent-as-text-color"
                                        [ngClass]="iconEmptyNotes"
                                        (click)="onNotesClick(d.data)"
                                    ></i>
                                </div>
                            </div>

                            <div *dxTemplate="let d of 'boardNotesCellTemplate'">
                                <div *ngIf="d.data.hasBoardNotes">
                                    <i
                                        class="cc-1-5x icon-content cc-icon-content cc-icon-check"
                                        [ngClass]="iconNotes"
                                        (click)="onBoardNotesClick(d.data)"
                                    ></i>
                                </div>

                                <div *ngIf="!d.data.hasBoardNotes">
                                    <i
                                        class="cc-1-5x icon-content dx-theme-accent-as-text-color"
                                        [ngClass]="iconEmptyNotes"
                                        (click)="onBoardNotesClick(d.data)"
                                    ></i>
                                </div>
                            </div>
                            <div *dxTemplate="let d of 'workflowTemplate'">
                                <app-hyperlink-creator
                                    actionCode="WORKFLOW_DETAILS"
                                    [displayText]="d.value"
                                    (onLinkClick)="onWorkflowClick(d.data)"
                                ></app-hyperlink-creator>
                            </div>

                            <div *dxTemplate="let row of 'workflowStatusCellTemplate'">
                                <app-workflow-status-link
                                    *ngIf="row.data.workflowStatus"
                                    [status]="row.data.workflowStatus"
                                ></app-workflow-status-link>
                            </div>
                            <dxo-summary>
                                <dxi-group-item
                                    column="workFlowId"
                                    summaryType="count"
                                    displayFormat="Count = {0}"
                                ></dxi-group-item>
                            </dxo-summary>
                        </dx-data-grid>
                    </cc-data-grid-features>
                </div>
            </dxi-item>
        </dx-box>
    </dxi-item>
</dx-box>

<app-workflow-notes-editor
    *ngIf="showWorkFlowNotesPopUp"
    [workflowId]="selectedWorkflow.workFlowId"
    [communityId]="selectedWorkflow.communityId"
    [hasNotes]="selectedWorkflow.hasNotes"
    (closeNotesPopUp)="onWorkflowNotesPopClose($event)"
></app-workflow-notes-editor>

<app-workflow-history
    *ngIf="showWorkFlowHistoryPopUp"
    [workflowId]="selectedWorkflow.workFlowId"
    [communityId]="selectedWorkflow.communityId"
    (onClose)="onWorkflowHistoryClose()"
></app-workflow-history>

<app-workflow-board-history
    *ngIf="showWorkFlowBoardHistoryPopUp"
    [workflowId]="selectedWorkflow.workFlowId"
    [communityId]="selectedWorkflow.communityId"
    (onClose)="onWorkflowBoardHistoryClose()"
></app-workflow-board-history>

<app-workflow-board-notes-editor
    *ngIf="showWorkFlowBoardNotesPopUp"
    [workflowId]="selectedWorkflow.workFlowId"
    [communityId]="selectedWorkflow.communityId"
    (closeNotesPopUp)="onWorkdlowBoardNotesPopClose($event)"
></app-workflow-board-notes-editor>

<app-workflow-reimbursement-editor
    *ngIf="showReimbursementEditor"
    [title]="reimbursementEditorTitle"
    [workflowId]="selectedWorkflow?.workFlowId"
    [communityId]="communityId"
    [managementCompanyId]="managementCompanyId"
    (onClose)="onReimbursementEdiorClose($event)"
></app-workflow-reimbursement-editor>

<app-workflow-viewer
    *ngIf="showWorkflowViewer"
    [viewOnly]="true"
    [workflowId]="selectedWorkflow?.workFlowId"
    [communityId]="selectedWorkflow?.communityId"
    (onClose)="showWorkflowViewer = false"
></app-workflow-viewer>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#workflowReimbursementRequest' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
